import useVuelidate from '@vuelidate/core';
import { mapActions, mapState } from 'vuex';

import bus from '@/utils/bus';
import { SNACKBAR_TYPES, VERIFY_MAIL_TYPES } from '@/utils/constants';
import { ERROR_EMAIL_EXPIRED } from '@/utils/errorCodeList';
import {
  password,
  required,
  sameAsPassword,
} from '@/utils/validators';

export default {
  name: 'SetPassword',
  setup() {
    return { setPwdValidator$: useVuelidate({ $lazy: true }) };
  },
  data() {
    return {
      company: '',
      email: '',
      form: {
        confirmPassword: '',
        password: '',
        subscribed_weiby: false,
      },
    };
  },
  computed: {
    ...mapState('user', {
      checkingToken: ({ checkTokenExpired }) => checkTokenExpired,
      settingPassword: ({ settingPassword }) => settingPassword,
    }),
    getPasswordMsg() {
      return this.hasErrorMsgs('password')
        ? this.getErrorMsgs('password') : '密碼長度必須8個字元以上，並且其中必須含英文字母及數字';
    },
  },
  beforeDestroy() {
    Object.assign(this.$data, this.$options.data.apply(this));
  },
  async created() {
    const token = this.$route?.query?.confirmation_token;
    if (!token) {
      this.$snackbar({
        type: SNACKBAR_TYPES.ERROR,
        title: '找不到驗證碼',
        msg: '請確認您的重設密碼網址無誤並重試。',
      });
      this.$router.replace('/login');
      return;
    }

    try {
      const { email = '', team_name: name = '' } = await this.checkTokenExpired(token);
      this.company = name;
      this.email = email;
      bus.$emit('TEMP_COMPANY_NAME', name);
    } catch (error) {
      const { message: msg, status } = error;
      this.$snackbar({
        type: SNACKBAR_TYPES.ERROR,
        title: 'Token驗證失敗',
        msg,
      });

      bus.$emit('CLEAR_TEMP_COMPANY_NAME');
      if (status === ERROR_EMAIL_EXPIRED) {
        this.$router.replace({ name: 'LinkOutdated', params: { company: this.company, type: VERIFY_MAIL_TYPES.SET_PASSWORD } });
      } else {
        this.$router.replace('/login');
      }
    }
  },
  methods: {
    ...mapActions('user', {
      checkTokenExpired: 'CHECK_TOKEN_EXPIRED',
      setPassword: 'SET_PASSWORD',
    }),
    async confirm() {
      const valid = await this.setPwdValidator$.$validate();
      if (!valid) return;

      try {
        await this.setPassword({
          confirmation_token: this.$route?.query?.confirmation_token,
          password: this.form?.confirmPassword,
          subscribed_weiby: this.subscribed_weiby,
        });
        bus.$emit('CLEAR_TEMP_COMPANY_NAME');
        const params = this.email ? { email: encodeURIComponent(this.email) } : {};
        this.$router.replace({ name: 'Login', params });
        this.$snackbar({ type: SNACKBAR_TYPES.SUCCESS, title: '密碼設定成功', msg: '請登入已享受便捷服務' });
      } catch (error) {
        const { message: msg } = error;
        this.$snackbar({ type: SNACKBAR_TYPES.ERROR, title: '密碼設定失敗', msg });
      }
    },
    getErrorMsgs(field) {
      return this.setPwdValidator$.form?.[field]?.$errors?.[0]?.$message;
    },
    hasErrorMsgs(field) {
      return !!this.setPwdValidator$.form?.[field]?.$errors?.length;
    },
  },
  validations() {
    return {
      form: {
        password: { required: required('密碼'), password },
        confirmPassword: { required: required('確認密碼'), sameAsPassword: sameAsPassword(() => this.form.password) },
      },
    };
  },
};
